import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class StockEarningSurprises extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
        console.log('StockEarningSurprises symbol', this.state.symbol, this.state.limit);
    }

    componentDidMount() {
        ApiService.getEarningSurprises(this.state.symbol)
            .then(result => {
                console.log('Earning Surprise', result);
                let filteredData = [];
                let length = this.state.limit === undefined ? 200 : this.state.limit;
                if (result.length > 0) {
                    length = result.length < length ? result.length : length;
                    for (var i = 0; i < length; i++) {
                        filteredData.push(result[i]);
                    }
                }
                this.setState({ list: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    renderRow(listValue) {
        //console.log('listValue', listValue);
        let resultColor = '';
        if (parseFloat(listValue.estimatedEarning) <= parseFloat(listValue.actualEarningResult)) {
            resultColor = 'green';
        } else if (parseFloat(listValue.estimatedEarning) > parseFloat(listValue.actualEarningResult)) {
            resultColor = 'red';
        }
        return (
            <tr key={listValue.date + Math.random()} style={{ color: resultColor }}>
                <td>{listValue.date}</td>
                <td>{listValue.estimatedEarning}</td>
                <td>{listValue.actualEarningResult}</td>
            </tr>
        )
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }
        let header = 'Stock Earning Release';
        if (this.state.limit !== undefined) {
            header = <><Link to={'/earningSurprises/' + this.state.symbol}>{header}</Link> <Link style={{ fontSize: "10px"}} to={'/earningSurprises/' + this.state.symbol}>(More Details)</Link></>
        } else {
            header += ' - ' + this.state.symbol;
        }

        return (
            <div>
                {header}
                <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Estimate</th>
                            <th>Actual
                                &nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Company releases Earning periodically, indicates growth if Actual is better than Estimate <br />
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default StockEarningSurprises;
